import { Formik } from 'formik';
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

import { ValidationLogin } from 'common/validations';
import PrimaryButton from 'components/form/buttons/primaryButton';
import TextIput from 'components/form/textInput';
import Gap from 'components/gap';
import PasswordInput from 'components/form/passwordInput';
import { useActions } from 'common/hooks/useActions';
import CheckBox from 'components/form/checkbox';

import * as S from '../../styles';

const LoginForm: React.FC = () => {
  const { logInRequestAction } = useActions();
  const history = useNavigate();

  return (
    <Formik
      initialValues={{ mail: '', password: '', remember_me: false }}
      validationSchema={ValidationLogin}
      onSubmit={(values, { setSubmitting }) => {
        logInRequestAction({ ...values, remember_me: JSON.stringify(values.remember_me) }, (path: string) => {
          history(path);
        });
        setSubmitting(false);
      }}
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        // isSubmitting,
        setValues
      }) => (
        <>
          <Gap size="24px" />
          <TextIput
            label="Email"
            type="text"
            name="mail"
            onChange={handleChange}
            onBlur={handleBlur}
            placeholder="Please enter your mail"
            value={values.mail}
            message={touched.mail && errors.mail}
            error={errors.mail as unknown as boolean}
          />
          <Gap size="16px" />
          <PasswordInput
            label="Password"
            name="password"
            onChange={handleChange}
            onBlur={handleBlur}
            placeholder="Please enter your password"
            value={values.password}
            message={touched.password && errors.password}
            error={errors.password as unknown as boolean}
          />
          <Gap size="16px" />
          <S.Links>
            <CheckBox
              theme="two"
              text={<>Remember me</>}
              style={{ alignItems: 'center' }}
              checked={values.remember_me}
              onChange={(val: boolean) => setValues({ ...values, remember_me: val })}
            />
            <Link to="/auth/forget-password">Forgot password?</Link>
          </S.Links>

          <Gap size="24px" />

          <PrimaryButton
            onClick={handleSubmit}
            type="submit"
            // disabled={isSubmitting}
            style={{ width: '100%' }}
          >
            Sign in
          </PrimaryButton>
        </>
      )}
    </Formik>
  );
};

export default LoginForm;
